{
  "name": "ringcentral-web-phone",
  "version": "1.0.1",
  "homepage": "https://github.com/ringcentral/ringcentral-web-phone",
  "bugs": {
    "url": "https://github.com/ringcentral/ringcentral-web-phone/issues"
  },
  "repository": {
    "type": "git",
    "url": "git://github.com/ringcentral/ringcentral-web-phone.git"
  },
  "license": "MIT",
  "author": {
    "name": "RingCentral, Inc.",
    "email": "devsupport@ringcentral.com"
  },
  "contributors": [
    {
      "name": "Kirill Konshin"
    },
    {
      "name": "Elias Sun"
    },
    {
      "name": "Vyshakh Babji"
    },
    {
      "name": "Yatin Gera"
    },
    {
      "name": "Tyler Liu"
    },
    {
      "name": "Embbnux Ji"
    }
  ],
  "main": "./lib/src/index.js",
  "types": "./lib/src/index.d.ts",
  "scripts": {
    "build": "rimraf lib && yarn tsc && rimraf docs && parcel build demo/index.html demo/end.html demo/PrivacyPolicy.html --dist-dir docs --public-url ./",
    "lint": "eslint --fix '**/*.{ts,tsx,js,jsx}' && prettier --write . && sort-package-json",
    "serve": "rimraf .parcel-cache && parcel demo/index.html demo/end.html demo/PrivacyPolicy.html --dist-dir docs",
    "test": "NODE_OPTIONS=--require=dotenv-override-true/config playwright test test/index.spec.ts --workers=1"
  },
  "dependencies": {
    "sip.js": "^0.21.2"
  },
  "devDependencies": {
    "@faker-js/faker": "^8.4.1",
    "@playwright/test": "^1.44.0",
    "@rc-ex/core": "^1.3.15",
    "@ringcentral/sdk": "^5.0.1",
    "@types/jest": "^29.5.12",
    "@types/node": "^20.12.11",
    "@typescript-eslint/eslint-plugin": "^7.8.0",
    "@typescript-eslint/parser": "^7.8.0",
    "bootstrap": "3.4.1",
    "buffer": "^6.0.3",
    "coveralls": "^3.1.1",
    "crypto-browserify": "^3.12.0",
    "dotenv-override-true": "^6.2.2",
    "eslint": "8.57.0",
    "eslint-config-alloy": "^5.1.2",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-jest": "^28.5.0",
    "eslint-plugin-prettier": "^5.1.3",
    "events": "^3.3.0",
    "http-server": "^14.1.1",
    "jest": "^29.7.0",
    "jquery": "^3.7.1",
    "parcel": "^2.12.0",
    "prettier": "^3.2.5",
    "process": "^0.11.10",
    "querystring-es3": "^0.2.1",
    "sort-package-json": "^2.10.0",
    "stream-browserify": "^3.0.0",
    "ts-jest": "^29.1.2",
    "ts-node": "^10.9.2",
    "ttpt": "^0.8.9",
    "typescript": "^5.4.5",
    "wait-for-async": "^0.6.1",
    "yarn-upgrade-all": "^0.7.2"
  },
  "preferGlobal": false,
  "targets": {
    "main": false,
    "module": false,
    "types": false,
    "browser": false
  },
  "yarn-upgrade-all": {
    "ignore": [
      "bootstrap",
      "eslint"
    ]
  }
}
